export default __webpack_public_path__ + "static/google-b0a68ddbc8337fdf08d7e2d38de2548d.png";